module.exports = __webpack_public_path__ + "static/media/DL-page.a11fdb42.png";